import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL, NAV_LINKS, COMPANY } from "../lib/constants";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#070707] border-t border-white/10"
        >
            <div className="container-bevel py-20 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
                <div className="md:col-span-5">
                    <div className="flex items-center gap-3">
                        <img
                            src={LOGO_URL}
                            alt="Bevel"
                            className="h-14 w-14 object-contain"
                        />
                        <div>
                            <div className="font-display text-xl text-white">
                                BEVEL
                            </div>
                            <div className="text-[10px] uppercase tracking-[0.25em] text-white/50">
                                Commercial Services
                            </div>
                        </div>
                    </div>
                    <p className="mt-6 text-sm leading-relaxed text-white/60 max-w-md">
                        Premium commercial and residential renovation partner.
                        Engineered for resale value, designed for ROI. Serving{" "}
                        {COMPANY.serviceArea}.
                    </p>
                </div>

                <div className="md:col-span-3">
                    <div className="overline">Site</div>
                    <ul className="mt-5 space-y-3">
                        {NAV_LINKS.map((l) => (
                            <li key={l.to}>
                                <Link
                                    to={l.to}
                                    data-testid={`footer-link-${l.to.replace(/\//g, "") || "home"}`}
                                    className="text-sm text-white/70 hover:text-[#F5A623] transition-colors"
                                >
                                    {l.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <div className="overline">Contact</div>
                    <ul className="mt-5 space-y-4 text-sm text-white/70">
                        <li className="flex items-start gap-3">
                            <Phone
                                size={14}
                                className="mt-1 text-[#F5A623] shrink-0"
                            />
                            <a
                                href={COMPANY.phoneHref}
                                className="hover:text-white"
                                data-testid="footer-phone"
                            >
                                {COMPANY.phone}
                            </a>
                        </li>
                        <li className="flex items-start gap-3">
                            <Mail
                                size={14}
                                className="mt-1 text-[#F5A623] shrink-0"
                            />
                            <a
                                href={COMPANY.emailHref}
                                className="hover:text-white"
                                data-testid="footer-email"
                            >
                                {COMPANY.email}
                            </a>
                        </li>
                        <li className="flex items-start gap-3">
                            <MapPin
                                size={14}
                                className="mt-1 text-[#F5A623] shrink-0"
                            />
                            <span data-testid="footer-address">
                                {COMPANY.address}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="container-bevel py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] text-white/55 uppercase tracking-[0.2em]">
                    <span>
                        © {new Date().getFullYear()} Bevel Commercial Services
                    </span>
                    <nav
                        aria-label="Legal"
                        className="flex items-center gap-5"
                    >
                        <Link
                            to="/privacy"
                            data-testid="footer-privacy-link"
                            className="text-white/70 hover:text-[#F5A623] transition-colors"
                        >
                            Privacy
                        </Link>
                        <Link
                            to="/terms"
                            data-testid="footer-terms-link"
                            className="text-white/70 hover:text-[#F5A623] transition-colors"
                        >
                            Terms
                        </Link>
                    </nav>
                    <a
                        href="https://builtby-ab.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="built-by-ab"
                        className="text-white/55 hover:text-[#F5A623] transition-colors"
                    >
                        Built by AB
                    </a>
                </div>
            </div>
        </footer>
    );
}
